export default function () {
  // this.getStaticComapny()
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/components/statistics/resources/mounted.js